
import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { useToast } from "@/hooks/use-toast";

export const useTasks = (isAdmin: boolean) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  const fetchTasks = async () => {
    try {
      setLoading(true);
      console.log("Henter tasks...");
      
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        console.log("Ingen aktiv session fundet");
        toast({
          title: "Ikke logget ind",
          description: "Du skal være logget ind for at se opgaver",
          variant: "destructive"
        });
        return;
      }

      console.log("Session fundet, henter opgaver...");

      let query = supabase
        .from('tasks')
        .select('*')
        .is('deleted_at', null); // Filtrer slettede opgaver fra
      
      if (!isAdmin) {
        query = query.eq('assigned_to', session.user.email);
      }

      const { data, error } = await query.order('created_at', { ascending: false });

      if (error) {
        console.error('Database fejl:', error);
        throw error;
      }

      console.log(`${data?.length || 0} opgaver hentet`);
      setTasks(data || []);
      
    } catch (error) {
      console.error('Fejl i fetchTasks:', error);
      toast({
        title: "Fejl ved hentning af opgaver",
        description: error.message || "Der opstod en uventet fejl",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  // Tilføj en listener for auth state changes
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        console.log("Auth state ændret, genindlæser opgaver...");
        fetchTasks();
      }
    });

    fetchTasks();

    return () => {
      subscription.unsubscribe();
    };
  }, [isAdmin]);

  return {
    tasks,
    loading,
    fetchTasks
  };
};
